import { render, staticRenderFns } from "./UserRoles.vue?vue&type=template&id=854e5566&scoped=true"
import script from "./UserRoles.vue?vue&type=script&lang=ts"
export * from "./UserRoles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854e5566",
  null
  
)

export default component.exports